import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    { questionKey: 'faq.q1', answerKey: 'faq.a1' },
    { questionKey: 'faq.q2', answerKey: 'faq.a2' },
    { questionKey: 'faq.q3', answerKey: 'faq.a3' },
    { questionKey: 'faq.q4', answerKey: 'faq.a4' },
    { questionKey: 'faq.q5', answerKey: 'faq.a5' },
    { questionKey: 'faq.q6', answerKey: 'faq.a6' },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-800 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('faq.title')} <span className="text-turquoise-500">{t('faq.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-navy-600">
            {t('faq.description')}
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-sand-50 to-sand-100 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow border border-sand-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-white/60 transition-colors"
              >
                <h4 className="text-base font-semibold text-navy-800 pr-4">
                  {t(faq.questionKey)}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-navy-700 flex-shrink-0`}></i>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5 border-t border-sand-200">
                  <p className="text-navy-600 leading-relaxed pt-4">
                    {t(faq.answerKey)}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
